/**
 * GMDSSConditionalQuestions - Extracted from StepSystems for file size management
 * Handles GMDSS matrix conditional questions based on vessel configuration
 */

import React from 'react';
import { HelpCircle } from 'lucide-react';
import WizardSection from '../../WizardSection';
import { VOYAGE_DURATION_OPTIONS, VISUAL_ALERTING_OPTIONS, WEATHER_INFO_OPTIONS, UK_WATERS_OPTIONS } from '../utils/gmdssMatrixLogic';

const GMDSSConditionalQuestions = ({ 
  gmdssResult, 
  conditionalQuestions, 
  draftConfig, 
  updateConfig 
}) => {
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 mb-6">
      <div className="flex items-start gap-3">
        <HelpCircle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <h4 className="font-medium text-amber-900 mb-2">Additional Information Required</h4>
          <p className="text-amber-800 text-sm mb-4">
            Your vessel configuration requires additional details to determine final GMDSS requirements.
          </p>
      <div className="space-y-4">
        {conditionalQuestions.includes('voyageDuration') && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Typical Voyage Duration
            </label>
            <select 
              value={draftConfig.voyageDuration || ''}
              onChange={(e) => updateConfig({ voyageDuration: e.target.value })}
              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-cyan-500 focus:ring-cyan-500 text-sm"
            >
              <option value="">Select voyage duration...</option>
              {Object.entries(VOYAGE_DURATION_OPTIONS).map(([value, label]) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </select>
          </div>
        )}
        {conditionalQuestions.includes('visualAlertingEffective') && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Visual Alerting Effectiveness
            </label>
            <select 
              value={draftConfig.visualAlertingEffective || ''}
              onChange={(e) => updateConfig({ visualAlertingEffective: e.target.value })}
              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-cyan-500 focus:ring-cyan-500 text-sm"
            >
              <option value="">Select alerting effectiveness...</option>
              {Object.entries(VISUAL_ALERTING_OPTIONS).map(([value, label]) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </select>
          </div>
        )}
        {conditionalQuestions.includes('alternativeWeatherInfo') && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Alternative Weather Information
            </label>
            <select 
              value={draftConfig.alternativeWeatherInfo || ''}
              onChange={(e) => updateConfig({ alternativeWeatherInfo: e.target.value })}
              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-cyan-500 focus:ring-cyan-500 text-sm"
            >
              <option value="">Select weather info availability...</option>
              {Object.entries(WEATHER_INFO_OPTIONS).map(([value, label]) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </select>
          </div>
        )}
        {conditionalQuestions.includes('operatesUKWaters') && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              UK Waters Operation
            </label>
            <select 
              value={draftConfig.operatesUKWaters || ''}
              onChange={(e) => updateConfig({ operatesUKWaters: e.target.value })}
              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-cyan-500 focus:ring-cyan-500 text-sm"
            >
              <option value="">Select UK waters operation...</option>
              {Object.entries(UK_WATERS_OPTIONS).map(([value, label]) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </select>
          </div>
        )}
      </div>
        </div>
      </div>
    </div>
  );
};

export default GMDSSConditionalQuestions;